import { useGetDataSourceApiUrl } from './use-get-data-source-api-url';

export const useDataSourceApiUrl = () => {
    return useGetDataSourceApiUrl()({});
}
